export default __webpack_public_path__ + "static/media/play.11a6ceeb.gif";